import React from "react";
import { ButtonRow } from "../button/ButtonRow";
import { Button } from "../button/Button";

type CloseModalButtonProps = {
    onClose:()=>void,
    buttonText?:string,
    buttonDisabled?:boolean
}
export function CloseModalButton(props:CloseModalButtonProps):JSX.Element
{
    return (
        <ButtonRow variant='right-aligned'>
            <Button variant='filled' text={props.buttonText || 'Luk'} onClick={props.onClose} disabled={props.buttonDisabled} />
        </ButtonRow>
    );
}